import { useState } from "react";
import { putClippingConfigURL, postClippingConfigURL} from "../../utils/ConstantsURL";

export const useSaveClippingConfig = ({ token }) => {
  const [loading, setLoading] = useState(false);

  const saveConfig = async ({ isEdit, isSection, config, userId, documentId }) => {
    setLoading(true);

    const dataToSend = {
      option: isSection ? "Seccion" : "Documento",
      config: {
        cover: config.Portada,
        index: config.Indice,
        dividers: config.Separador,
      },
    };

    try {
      if (isEdit) {
        console.log(config)
        await fetch(putClippingConfigURL(config.ID), {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(dataToSend),
        });
      } else {
        await fetch(postClippingConfigURL(), {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            ...dataToSend,
            id_user: userId,
            id_documento: documentId,
          }),
        });
      }
      return { success: true };
    } catch (error) {
      console.error("Error al guardar configuración:", error);
      return { success: false, error };
    } finally {
      setLoading(false);
    }
  };

  return { saveConfig, loading };
};
